import React, {ReactElement, ReactNode, useEffect, useState} from "react";
import {
    AppBar,
    Button,
    Card,
    Chip,
    Container,
    Grid,
    IconButton,
    Paper,
    Stack,
    TextField,
    Toolbar,
    useTheme
} from "@mui/material";
import {DashboardPanel} from "./DashboardPanel";





export const Dashboard : React.FC = () => {

    const [numberOfPanels, setNumberOfPanels] = useState(1)
    const [panels, setPanels] = useState<ReactNode[]>([])



    useEffect(() => {
        const panels : ReactNode[] = []
        for (let i = 0; i < numberOfPanels; i++) {
            panels.push(<DashboardPanel key={`dashboard-panel-${i}`} id={i} onDeletePanel={() => {
                setNumberOfPanels(numberOfPanels-1)
            }} onDuplicatePanel={() => {
                setNumberOfPanels(numberOfPanels+1);
            }} ></DashboardPanel>)
        }
        setPanels(panels);

    }, [numberOfPanels]);

    return (
        // <Container>
            <Grid container spacing={2}>
                    {panels.map((panel, i) =>
                        <Grid key={`dashboard-parent-${i}`} item xs={12/numberOfPanels}>
                            {panel}
                        </Grid>
                    )}
            </Grid>
        // </Container>
    )
}